import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "albumViewAll"

// Persists "Mine / All" preference to localStorage and restores it on page load.
export default class extends Controller {
  connect() {
    const showAll = localStorage.getItem(STORAGE_KEY) === "1"
    const urlHasShowAll = new URLSearchParams(window.location.search).get("show_all") === "1"

    // Restore preference from localStorage if it doesn't match the current URL
    if (showAll && !urlHasShowAll) {
      this.navigateTo(this.allUrl())
    } else if (!showAll && urlHasShowAll) {
      this.navigateTo(this.mineUrl())
    }
  }

  showAll(event) {
    event.preventDefault()
    localStorage.setItem(STORAGE_KEY, "1")
    this.navigateTo(this.allUrl())
  }

  showMine(event) {
    event.preventDefault()
    localStorage.removeItem(STORAGE_KEY)
    this.navigateTo(this.mineUrl())
  }

  allUrl() {
    const url = new URL(window.location.href)
    url.searchParams.set("show_all", "1")
    // Clear creator filter so it doesn't conflict
    url.searchParams.delete("q[creator_id_eq]")
    url.searchParams.delete("q[creator_full_name_in][]")
    return url.toString()
  }

  mineUrl() {
    const url = new URL(window.location.href)
    url.searchParams.delete("show_all")
    url.searchParams.delete("q[creator_id_eq]")
    url.searchParams.delete("q[creator_full_name_in][]")
    return url.toString()
  }

  navigateTo(url) {
    window.location.href = url
  }
}
